export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-digg-7a105a16fab935d46e4ef73bc177b03e.svg";